// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// ===========================================================================
//  Stiletto 標準イベント（v5.2.2 デフォルト）
// ===========================================================================

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


// ===========================================================================
//  AIVEC カスタム拡張
//  ---------------------------------------------------------------------------
//  Stiletto v2.1.1 当時に動作していたカスタム機能を v5.2.2 へ復元したもの。
//  元ソース : feature/seo-schema ブランチの assets/custom-events.js (旧L70 以降)
//  失効原因 : commit 85d4269 "Stiletto v5.2.2 へのテーマ更新＋カスタマイズ実装"
//             でテーマ標準ファイルに上書きされ消失。
//  復元日時 : 2026-05-07 (feature/restore-custom-events-js ブランチ)
//
//  含まれる機能:
//   1. 注文メモ（カートメモ）の localStorage 保持・カート0時クリア
//   2. 顧客登録ページの郵便番号 → 住所自動補完（zipcloud API）
//   3. ギフトセット（giftset）商品の Infinite Options アコーディオン開閉
//   4. ギフトセット価格小計のリアルタイム表示（#giftPrice / #productList）
//   5. レスポンシブ時のヘッダーちらつき防止（.header-custom-menu）
//   6. 外部リンクの target="_blank" 自動付与
//
//  v5.2.2 へのマークアップ追従のため、各処理に存在チェック（null guard）を
//  追加してあります（旧版は要素未存在時に例外を投げる作りだった）。
// ===========================================================================

// --- 注文メモ：ページ読み込み時にカートが空ならローカルストレージをクリア ---
window.addEventListener('load', function () {
    var cartCount = document.querySelector('[data-js-cart-count]');
    if (cartCount && cartCount.textContent == '0') {
        localStorage.removeItem('orderNote');
        updateCartInfo('');
    }
});

// --- 入力イベント：郵便番号・カートメモ ---
document.addEventListener('input', function (e) {
    // お客様登録の郵便番号を入力した場合
    if ('default_address.zip' == e.target.name) {
        inputPostNo(e.target.value);
    }
    // カートメモ入力イベント
    if ('CartSpecialInstructions' == e.target.id) {
        var noteText = e.target.value;
        updateCartInfo(noteText);
        localStorage.setItem('orderNote', noteText);
    }
});

/**
 * カート情報（note）を Shopify に反映する
 */
function updateCartInfo(noteText) {
    fetch('/cart.json')
        .then(function (response) { return response.json(); })
        .then(function (cartData) {
            cartData.note = noteText;
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cartData)
            });
        });
}

/**
 * 郵便番号を元に住所を自動取得する（zipcloud API）
 */
function inputPostNo(zipcode) {
    fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + zipcode)
        .then(function (response) { return response.json(); })
        .then(function (data) {
            var registerForm = document.forms.RegisterForm;
            if (!registerForm) return;
            var cfForm = registerForm.cfForm;
            if (!cfForm) return;

            var dropdown = registerForm['default_address.province'];
            if (!dropdown) return;

            // 初期値
            dropdown.selectedIndex = 0;
            cfForm.setFieldValue('default_address.province', '');

            // ドロップダウンメニューの各オプションをループでチェック
            for (var i = 0; i < dropdown.options.length; i++) {
                var optionText = dropdown.options[i].text;
                var optionValue = dropdown.options[i].value;

                if (data.results != null && data.results[0].address1 != null) {
                    if (data.results[0].address1 === optionText) {
                        dropdown.selectedIndex = i;
                        cfForm.setFieldValue('default_address.province', optionValue);
                        break;
                    }
                }
            }

            // 市区町村
            var city = "";
            if (data.results != null && data.results[0].address2 != null) {
                city += data.results[0].address2;
            }
            if (data.results != null && data.results[0].address3 != null) {
                city += data.results[0].address3;
            }
            cfForm.setFieldValue('default_address.city', city);
        });
}

// --- ギフトセットのアコーディオン処理（Infinite Options 連動）---
// 「infiniteoptions-container」内をクリックされたら、対応する選択肢ブロックを開閉
document.addEventListener('click', function (event) {
    var clickedElement = event.target;
    var clickedElementId = clickedElement.id;

    var container = document.getElementById('infiniteoptions-container');
    if (container == null) return;

    // クリックされた id を aria-labelledby に持つ要素（ラジオボタン群の親）を取得
    var elements = container.querySelectorAll('[aria-labelledby="' + clickedElementId + '"]');
    if (elements[0] === undefined) return;

    // children[0]: 説明 div / children[1]: 実際のラジオボタン span（こちらが目的）
    if (elements[0].children.length < 1) return;
    var element = elements[0].children[1];
    if (!element) return;

    // ラジオボタンに小計再計算リスナーを付与
    var labels = element.querySelectorAll('input');
    labels.forEach(function (label) {
        label.addEventListener('click', function () {
            ShowGiftSetProductDetail();
        });
    });

    // 表示状態をトグル
    var newStyleRule = '';
    if (element.style.display === 'none' || element.style.display === '') {
        newStyleRule = '#' + clickedElementId + '::after { display: none; }';
        element.style.display = 'block';
    } else {
        newStyleRule = '#' + clickedElementId + '::after { display: block; }';
        element.style.display = 'none';
    }
    // 疑似要素（::after）のスタイルは <style> タグ追加でしか変えられないため
    var styleTag = document.createElement('style');
    styleTag.innerHTML = newStyleRule;
    document.head.appendChild(styleTag);
});

/**
 * ギフトセットの選択商品から小計を計算し #giftPrice に描画する
 *  - 単価ソース: #productList 内の <p> テキスト（"商品名 ￥XX,XXX" 形式）
 *  - 【MEN】商品は固定 ¥1,980
 *  - 箱代等のセレクトボックス（#option1, #option2）の値も加算
 *  - 元実装は ￥XX,XXX を100倍した数値を /100 で戻す独特なロジック
 */
function ShowGiftSetProductDetail() {
    var container = document.getElementById('infiniteoptions-container');
    var productList = document.getElementById('productList');
    if (!container || !productList) return;

    var divElement = document.getElementById('giftPrice');
    if (!divElement) return;

    var priceEl = document.querySelector('span[data-price]');
    if (!priceEl) return;

    var pTagsProductList = productList.getElementsByTagName('p');
    var productData = container.querySelectorAll('input[type="radio"]:checked');
    var newElementList = [];

    // ギフトセット商品の表示価格を取得
    var giftPrice = priceEl.innerHTML;
    var smallIdx = giftPrice.indexOf('<small>');
    if (smallIdx > -1) {
        giftPrice = giftPrice.substring(0, smallIdx);
    }

    // 通貨記号と数値部の分離
    var currency = giftPrice.replace(/[0-9]/g, '').replace(",", "").replace(".", "");

    var totalPrice = 0;
    var optionsPrice = 0;

    /**
     * 商品名を比較用に正規化
     */
    function normalizeString(str) {
        return str
            .replace(/[0-9_]+/g, '')
            .replace(/胡粉ネイル\s*/g, '')
            .trim();
    }

    // 選択されたラジオボタン1つずつに対して単価を引き当て
    for (var i = 0; i < productData.length; i++) {
        var newElement = document.createElement("p");
        var price = 0;
        var title = productData[i].value.trim();

        if (title.indexOf("【MEN】") !== -1) {
            // MEN シリーズは固定価格
            price = 1980;
        } else {
            var isMatched = false;
            Array.from(pTagsProductList).forEach(function (pTagProduct) {
                var productText = pTagProduct.textContent.trim();
                if (normalizeString(productText) === normalizeString(title)) {
                    var extractedPrice = productText.match(/[\d,]+/);
                    if (extractedPrice) {
                        // /100 はテンプレ側の price フォーマット仕様に合わせた除算（旧版踏襲）
                        price = Number(extractedPrice[0].replace(/,/g, '')) / 100;
                    }
                    isMatched = true;
                }
            });
            if (!isMatched) price = 0;
        }

        totalPrice += price;

        var newContent = document.createTextNode("(" + (i + 1) + ') ' + title);
        var priceSpan = document.createElement("span");
        priceSpan.style.float = "right";
        priceSpan.appendChild(getCurrencyPosition(price.toLocaleString(), currency));
        newElement.appendChild(newContent);
        newElement.appendChild(priceSpan);
        newElementList.push(newElement);
    }

    /**
     * #option1 / #option2（箱代等）の選択値から金額を抽出
     */
    function getOptionsPrice() {
        var ids = ["option1", "option2"];
        var sum = 0;
        ids.forEach(function (optionId) {
            var selectBox = document.getElementById(optionId);
            if (selectBox) {
                var selectedOption = selectBox.options[selectBox.selectedIndex].value;
                var extractedPrice = selectedOption.match(/￥([\d,]+)/);
                if (extractedPrice) {
                    sum += Number(extractedPrice[1].replace(/,/g, ''));
                }
            }
        });
        return sum;
    }

    optionsPrice = getOptionsPrice();
    if (optionsPrice > 0) {
        totalPrice += optionsPrice;

        var boxElement = document.createElement("p");
        var boxLabel = document.createTextNode('箱代');
        var boxPriceSpan = document.createElement("span");
        boxPriceSpan.style.float = "right";
        boxPriceSpan.appendChild(getCurrencyPosition(optionsPrice.toLocaleString(), currency));
        boxElement.appendChild(boxPriceSpan);
        boxElement.appendChild(boxLabel);
        newElementList.push(boxElement);
    }

    // 合計行
    var totalElement = document.createElement("p");
    var totalLabel = document.createTextNode('合計');
    var totalPriceSpan = document.createElement("span");
    totalPriceSpan.style.float = "right";
    totalPriceSpan.appendChild(getCurrencyPosition(totalPrice.toLocaleString(), currency));
    totalElement.appendChild(totalPriceSpan);
    totalElement.appendChild(totalLabel);
    newElementList.push(totalElement);

    // 既存ノードをクリアして新規描画
    while (divElement.firstChild) {
        divElement.removeChild(divElement.firstChild);
    }
    newElementList.forEach(function (newElem) {
        divElement.appendChild(newElem);
    });
}

// --- 選択肢（option1, option2）の change で小計再計算 ---
["option1", "option2"].forEach(function (optionId) {
    var selectBox = document.getElementById(optionId);
    if (selectBox) {
        selectBox.addEventListener('change', ShowGiftSetProductDetail);
    }
});

/**
 * 通貨記号位置（前置）
 */
function getCurrencyPosition(price, currency) {
    return document.createTextNode(currency + price);
}

// --- 初期実行（ギフトセット商品ページの場合のみ） ---
if (document.getElementById('infiniteoptions-container')) {
    ShowGiftSetProductDetail();
}

// --- レスポンシブ時のヘッダー（多言語メニュー）ちらつき防止 ---
window.addEventListener('scroll', function () {
    var element = document.querySelector('.header-custom-menu');
    if (element == null) return;

    var scrollPosition = window.scrollY;
    if (element.style.display != 'none') {
        if (scrollPosition >= 60) {
            element.style.display = 'none';
        }
    } else {
        if (scrollPosition <= 5) {
            element.style.display = '';
        }
    }
});

// --- 外部ドメインへのリンクは新規タブで開く ---
var links = document.links;
for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}
